import { getFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-18464 Отображать ли новый UI для личных документов */
export const enableNewPersonalDocuments = getFeature('new-personal-documents') || false;
